import { randCompanyName } from '@ngneat/falso';
import {
  IPartnerApp,
  IPartnerAppOAuth,
} from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock, Properties, uid } from '@principle-theorem/shared';

export class PartnerAppMock
  extends BaseFirestoreMock<Properties<Omit<IPartnerApp, 'appIconUrl'>>>
  implements Properties<Omit<IPartnerApp, 'appIconUrl'>>
{
  name = randCompanyName();
  appIconUrl?: string = undefined;
  oauth: IPartnerAppOAuth = {
    clientId: uid(true),
    clientSecrets: [],
    redirectUri: '',
    scopes: [],
  };
}
